"use strict";

var StoresHelper = {
	getWizardValue(wizardContent, propertyName, tokens) {
		// This method keeps us from needing to add the same methods to every store and action class.
		if (!tokens) {
			return this._getValue(wizardContent, propertyName);
		}

		return this._getTokenizedValue(wizardContent, propertyName, tokens);
	},

	_getTokenizedValue(wizard, propertyName, tokens) {
		var tokenizedValue = this._getValue(wizard, propertyName);

		if (tokenizedValue) {
			for (var key in tokens) {
				var token = `{${key}}`;
				tokenizedValue = tokenizedValue.replace(token, tokens[key]);
			}
		}

		return tokenizedValue;
	},

	_getValue(wizard, propertyName) {
		if (wizard) {
			return wizard[propertyName];
		}
	}
};

module.exports = StoresHelper;
